module.exports = __webpack_public_path__ + "assets/algoritmo_mobile_oculto_bacterias.9a0dfad0.svg";